import { ActionType } from "../../../../../../react-core/Flux/ActionType";
import { ClientAccountClient } from "../../../../../../Wrap/Api/Account/ClientAccount";
import { AccountRolesClient } from "../../../../../../Wrap/Api/Customer/AccountRoles";
import { PersonalDetailClient } from "../../../../../../Wrap/Api/Customer/PersonalDetail";
import { CappedPensionArrangementsFlexiConversionAvailabilitiesClient } from "../../../../../../Wrap/Api/Drawdown/CappedPensionArrangementsFlexiConversionAvailabilities";
import { CappedPensionArrangementsFlexiConversionInstructionsClient } from "../../../../../../Wrap/Api/Drawdown/CappedPensionArrangementsFlexiConversionInstructions";
import { InstructionStatus } from "../../../../../../Wrap/Constants/Enums/Domain/InstructionStatus";
import { CappedPensionArrangementsFlexiConversionInstruction } from "../../../../../../Wrap/Models/Domains/Drawdown/CappedPensionArrangementsFlexiConversionInstruction";
import { ConvertToFlexiInstructionDispatcher, ConvertToFlexiInstructionStore, CappedPensionArrangementsFlexiConversionAvailabilitiesStore, CappedPensionArrangementsFlexiConversionAvailabilitiesDispatcher, PersonalDetailsStore, PersonalDetailsDispatcher, ClientAccountStore, ClientAccountDispatcher } from "../Store/Variable";

export class ConvertToFlexiAction {

    public static getInstruction(instructionId: number, subAccountHierarchyId: string): void {
        const client = new CappedPensionArrangementsFlexiConversionInstructionsClient();
        if (instructionId && instructionId != undefined) {
            const promise = client.get(
                instructionId
            );
            this.updateConvertToFlexiInstructionStore(promise);
        }
        else {
            const newInstruction: CappedPensionArrangementsFlexiConversionInstruction = {
                SubAccountHierarchyId: subAccountHierarchyId,
                Status: InstructionStatus.Pending
            }
            const promise = client.post(newInstruction);
            this.updateConvertToFlexiInstructionStore(promise);
        }
    }

    public static getPersonalDetailsByHierarchyId(subAccountHierarchyId: string): void {
        const client = new AccountRolesClient();
        const promise = client.get(subAccountHierarchyId);
        promise.onSuccess((result) => {
            const promise = new PersonalDetailClient().get(result[0].Customer.CustomerId);
                this.updatePersonalDetailsStore(promise);
        });
    }

    public static getClientAccountByHierarchyId(subAccountHierarchyId: string): void {
        const client = new ClientAccountClient();
        const promise = client.get(subAccountHierarchyId);
        this.updateClientAccountStore(promise);
    }

    public static getArrangementDetails(subAccountHierarchyId: string): void {
        const availabilitiesClient  = new CappedPensionArrangementsFlexiConversionAvailabilitiesClient();
        const promise = availabilitiesClient.get(
            subAccountHierarchyId
        );
        this.updateCappedPensionArrangementsFlexiConversionAvailabilitiesStaticStore(promise);
    }

    public static saveInstruction(data: CappedPensionArrangementsFlexiConversionInstruction, callback?: (result) => void): void {
        const client = new CappedPensionArrangementsFlexiConversionInstructionsClient();
        const promise = client.put(data.Id, data);
        promise.onSuccess((result) => {
            if (callback) {callback(result);}
        });
    }

    public static submitInstruction(data: CappedPensionArrangementsFlexiConversionInstruction, callback?): void {
        data.Status = InstructionStatus.Submitted;
        const client = new CappedPensionArrangementsFlexiConversionInstructionsClient();
        const promise = client.put(data.Id, data);
        promise.onSuccess((result) => {
            if (callback) {callback();}
        });
    }

    public static deleteInstruction(id, callback?): void {
        Promise.resolve(callback());
    }

    private static updateClientAccountStore(promise: any) {
        promise.onSuccess((result) => {
            let data = JSON.parse(JSON.stringify(ClientAccountStore.getData()));
            if (!data) {data = {};}
            data = result;
            ClientAccountDispatcher.dispatch({
                actionType: ActionType.Success,
                payload: data,
            });
        });

        promise.onError((err) => {
            ClientAccountDispatcher.dispatch({
                actionType: ActionType.Error,
                payload: err,
            });
        });
    }

    private static updatePersonalDetailsStore(promise: any) {
        promise.onSuccess((result) => {
            let data = JSON.parse(JSON.stringify(PersonalDetailsStore.getData()));
            if (!data) {data = {};}
            data = result;
            PersonalDetailsDispatcher.dispatch({
                actionType: ActionType.Success,
                payload: data,
            });
        });

        promise.onError((err) => {
            PersonalDetailsDispatcher.dispatch({
                actionType: ActionType.Error,
                payload: err,
            });
        });
    }

    private static updateConvertToFlexiInstructionStore(promise: any) {
        promise.onSuccess((result) => {
            let data = JSON.parse(JSON.stringify(ConvertToFlexiInstructionStore.getData()));
            if (!data) {data = {};}
            data = result;
            ConvertToFlexiInstructionDispatcher.dispatch({
                actionType: ActionType.Success,
                payload: data,
            });
        });

        promise.onError((err) => {
            ConvertToFlexiInstructionDispatcher.dispatch({
                actionType: ActionType.Error,
                payload: err,
            });
        });
    }

    private static updateCappedPensionArrangementsFlexiConversionAvailabilitiesStaticStore(promise: any) {
        promise.onSuccess((result) => {
            let data = JSON.parse(JSON.stringify(CappedPensionArrangementsFlexiConversionAvailabilitiesStore.getData()));
            if (!data) data = {};
            data = result;
            CappedPensionArrangementsFlexiConversionAvailabilitiesDispatcher.dispatch({
                actionType: ActionType.Success,
                payload: data,
            });
        });

        promise.onError((err) => {
            CappedPensionArrangementsFlexiConversionAvailabilitiesDispatcher.dispatch({
                actionType: ActionType.Error,
                payload: err,
            });
        });
    }
}
